export default __webpack_public_path__ + "static/media/character-yoshihisa.db8d5e37.png";